import React from "react";

const ErrorMessage = ({ children }) => {
  return <span className="error">{children}</span>;
};

export default ErrorMessage;
